(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
if (!customElements.get('wk-article-toc-anker')) {
  customElements.define('wk-article-toc-anker', class extends HTMLElement {
    constructor() {
      super();
      this.initialize = this.initialize.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onHashChange = this.onHashChange.bind(this);
    }

    connectedCallback() {
      if (this.initialized) {
        this.connectEvents();
      } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
      } else {
        this.initialize();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.initialize);
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('hashchange', this.onHashChange);
      this.listening = false;
    }

    connectEvents() {
      if (this.listening || !this.links || !this.links.length) return;
      this.addEventListener('click', this.onClick);
      window.addEventListener('hashchange', this.onHashChange);
      this.listening = true;
    }

    setActive(link) {
      this.links.forEach((item) => {
        if (item === link) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });
    }

    onClick(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('.wk-article-toc__link');
      if (link && this.contains(link)) this.setActive(link);
    }

    onHashChange() {
      const link = this.links.find((item) => item.hash === window.location.hash);
      if (link) this.setActive(link);
    }

    initialize() {
      if (this.initialized) return;
      const content = document.getElementById(this.dataset.contentId);
      const list = this.querySelector('[data-wk-toc-list]');
      if (!content || !list) return;

      const idCounts = new Map();
      document.querySelectorAll('[id]').forEach((element) => {
        idCounts.set(element.id, (idCounts.get(element.id) || 0) + 1);
      });
      const selector = this.dataset.includeH3 === 'true' ? 'h2, h3' : 'h2';
      const fragment = document.createDocumentFragment();
      const targets = [];
      this.links = [];

      content.querySelectorAll(selector).forEach((heading, index) => {
        const text = heading.textContent.replace(/\s+/g, ' ').trim();
        if (!text || this.contains(heading) || heading.closest('[hidden], [aria-hidden="true"], [data-wk-toc-ignore]')) return;
        if (!heading.id || /\s/.test(heading.id) || idCounts.get(heading.id) > 1) {
          const baseId = 'wk-' + content.id + '-' + (index + 1);
          let id = baseId;
          let suffix = 2;
          while (idCounts.has(id)) id = baseId + '-' + suffix++;
          heading.id = id;
          idCounts.set(id, 1);
        }
        heading.setAttribute('data-wk-toc-heading', '');
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');

        const item = document.createElement('li');
        item.className = 'wk-article-toc__item';
        if (heading.tagName === 'H3') item.classList.add('wk-article-toc__item--subheading');
        const link = document.createElement('a');
        link.className = 'wk-article-toc__link';
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = text;
        item.appendChild(link);
        fragment.appendChild(item);
        this.links.push(link);
        targets.push(heading);
      });

      list.replaceChildren(fragment);
      this.initialized = true;
      if (!targets.length) return;

      const firstParagraph = content.querySelector('p');
      if (firstParagraph) firstParagraph.after(this);
      else content.prepend(this);
      this.hidden = false;
      this.connectEvents();

      let hash = '';
      try {
        hash = decodeURIComponent(window.location.hash.slice(1));
      } catch {}
      const targetIndex = targets.findIndex((heading) => heading.id === hash);
      this.setActive(this.links[targetIndex < 0 ? 0 : targetIndex]);
      if (targetIndex >= 0) {
        requestAnimationFrame(() => targets[targetIndex].scrollIntoView({ block: 'start', behavior: 'instant' }));
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-arrivals-slider')) {
    customElements.define('new-arrivals-slider', class extends HTMLElement {
      connectedCallback() {
        this.rootSection = this.closest('.na-slider');
        this.track = this.querySelector('[data-na-track]');
        this.slides = Array.from(this.querySelectorAll('[data-na-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-na-dot]'));
        this.previousButton = this.rootSection.querySelector('[data-na-previous]');
        this.nextButton = this.rootSection.querySelector('[data-na-next]');
        this.autoplayButton = this.rootSection.querySelector('[data-na-autoplay]');

        if (!this.track || this.slides.length < 2) return;

        this.currentIndex = 0;
        this.rafId = null;
        this.autoplayTimer = null;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplayInterval = Math.max(3000, Number(this.dataset.autoplayInterval) || 5000);
        this.userPaused = false;
        this.interactionPaused = false;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleScroll = this.handleScroll.bind(this);
        this.previous = () => {
          this.goTo(this.currentIndex - 1);
          this.restartAutoplay();
        };
        this.next = () => {
          this.goTo(this.currentIndex + 1);
          this.restartAutoplay();
        };
        this.toggleAutoplay = () => {
          this.userPaused = !this.userPaused;
          this.updateAutoplayButton();
          this.restartAutoplay();
        };
        this.pauseForInteraction = () => {
          this.interactionPaused = true;
          this.stopAutoplay();
        };
        this.resumeAfterInteraction = (event) => {
          if (event.type === 'focusout' && this.rootSection.contains(event.relatedTarget)) return;
          if (event.type === 'pointerleave' && this.rootSection.contains(document.activeElement)) return;
          this.interactionPaused = false;
          this.startAutoplay();
        };
        this.handleVisibility = () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        };
        this.handleMotionChange = () => {
          this.updateAutoplayButton();
          this.restartAutoplay();
        };

        this.previousButton?.addEventListener('click', this.previous);
        this.nextButton?.addEventListener('click', this.next);
        this.autoplayButton?.addEventListener('click', this.toggleAutoplay);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
          this.goTo(index);
          this.restartAutoplay();
        }));
        this.rootSection.addEventListener('pointerenter', this.pauseForInteraction);
        this.rootSection.addEventListener('pointerleave', this.resumeAfterInteraction);
        this.rootSection.addEventListener('focusin', this.pauseForInteraction);
        this.rootSection.addEventListener('focusout', this.resumeAfterInteraction);
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.motionQuery.addEventListener('change', this.handleMotionChange);
        this.updateControls();
        this.updateAutoplayButton();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.previous);
        this.nextButton?.removeEventListener('click', this.next);
        this.autoplayButton?.removeEventListener('click', this.toggleAutoplay);
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.rootSection?.removeEventListener('pointerenter', this.pauseForInteraction);
        this.rootSection?.removeEventListener('pointerleave', this.resumeAfterInteraction);
        this.rootSection?.removeEventListener('focusin', this.pauseForInteraction);
        this.rootSection?.removeEventListener('focusout', this.resumeAfterInteraction);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        this.motionQuery?.removeEventListener('change', this.handleMotionChange);
        this.stopAutoplay();
        if (this.rafId) cancelAnimationFrame(this.rafId);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        this.currentIndex = nextIndex;
        this.updateControls();
        const trackLeft = this.track.getBoundingClientRect().left;
        const slideLeft = this.slides[nextIndex].getBoundingClientRect().left;
        const targetLeft = this.track.scrollLeft + slideLeft - trackLeft;
        this.track.scrollTo({ left: targetLeft, behavior: this.motionQuery.matches ? 'instant' : 'smooth' });
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.autoplayEnabled || this.userPaused || this.interactionPaused || document.hidden || this.motionQuery.matches) return;

        this.autoplayTimer = window.setTimeout(() => {
          const nextIndex = (this.currentIndex + 1) % this.slides.length;
          this.goTo(nextIndex);
          this.startAutoplay();
        }, this.autoplayInterval);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      updateAutoplayButton() {
        if (!this.autoplayButton) return;

        const reducedMotion = this.motionQuery.matches;
        const paused = this.userPaused || reducedMotion;
        const pauseIcon = this.autoplayButton.querySelector('[data-na-pause-icon]');
        const playIcon = this.autoplayButton.querySelector('[data-na-play-icon]');

        this.autoplayButton.disabled = reducedMotion;
        this.autoplayButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
        this.autoplayButton.setAttribute('aria-label', paused ? 'Start autoplay' : 'Pause autoplay');
        if (pauseIcon) pauseIcon.hidden = paused;
        if (playIcon) playIcon.hidden = !paused;
      }

      handleScroll() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = requestAnimationFrame(() => {
          const trackStart = this.track.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Infinity;

          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - trackStart);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          if (closestIndex !== this.currentIndex) {
            this.currentIndex = closestIndex;
            this.updateControls();
          }
        });
      }

      updateControls() {
        if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
        this.dots.forEach((dot, index) => {
          const active = index === this.currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wenoker-product-highlights"] && !Shopify.designMode) return;
  try {
    
  function wpInitHighlights(root) {
    root.querySelectorAll('[data-wp-highlights]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const cards = [...section.querySelectorAll('.wp-highlights__card')];
      const desktop = window.matchMedia('(min-width: 750px)');
      cards.forEach((card) => {
        const activate = () => {
          if (!desktop.matches) return;
          cards.forEach((other) => {
            other.open = other === card;
            other.classList.toggle('is-hover-open', other === card);
          });
        };
        const deactivate = () => {
          if (!desktop.matches || !card.classList.contains('is-hover-open')) return;
          card.open = false;
          card.classList.remove('is-hover-open');
        };
        card.addEventListener('mouseenter', activate);
        card.addEventListener('mouseleave', deactivate);
      });
      desktop.addEventListener('change', () => {
        cards.forEach((card) => card.classList.remove('is-hover-open'));
      });
    });
  }
  wpInitHighlights(document);
  document.addEventListener('shopify:section:load', (event) => wpInitHighlights(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wk-black-friday-2026"] && !Shopify.designMode) return;
  try {
    
  function initWkBlackFriday(root) {
    if (root.dataset.wkbfReady === 'true') return;
    root.dataset.wkbfReady = 'true';
    const tabs = [...root.querySelectorAll('[data-wkbf-tab]')];
    const panels = [...root.querySelectorAll('[data-wkbf-panel]')];
    const carouselUpdates = new Map();
    panels.forEach(panel => {
      const rail = panel.querySelector('[data-wkbf-cards]');
      const cards = [...rail.querySelectorAll('.wkbf__card')];
      const controls = panel.querySelector('[data-wkbf-carousel-controls]');
      const previous = panel.querySelector('[data-wkbf-prev]');
      const next = panel.querySelector('[data-wkbf-next]');
      const status = panel.querySelector('[data-wkbf-carousel-status]');
      const closestIndex = () => cards.reduce((best, card, index) =>
        Math.abs(card.offsetLeft - rail.scrollLeft) < Math.abs(cards[best].offsetLeft - rail.scrollLeft) ? index : best, 0);
      const update = () => {
        if (panel.hidden) return;
        const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        controls.hidden = cards.length < 2 || maxScroll <= 2;
        if (controls.hidden) return;
        status.textContent = `${closestIndex() + 1} / ${cards.length}`;
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maxScroll - 2;
      };
      const move = direction => {
        if (!cards.length) return;
        const targetIndex = Math.max(0, Math.min(cards.length - 1, closestIndex() + direction));
        const targetLeft = Math.min(cards[targetIndex].offsetLeft, rail.scrollWidth - rail.clientWidth);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        rail.scrollTo({ left: targetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, { passive: true });
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
      else window.addEventListener('resize', update);
      carouselUpdates.set(panel, update);
      update();
    });
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach(item => { const active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        panels.forEach(panel => { panel.hidden = panel.dataset.wkbfPanel !== tab.dataset.wkbfTab; if (!panel.hidden) carouselUpdates.get(panel)?.(); });
      });
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        next.focus(); next.click();
      });
    });
    const timer = root.querySelector('[data-wkbf-timer]');
    const timerLabel = root.querySelector('[data-wkbf-timer-label]');
    const promo = root.querySelector('[data-wkbf-promo]');
    const showCountdown = promo.dataset.showCountdown === 'true';
    const start = Date.parse(root.dataset.start || '');
    const end = Date.parse(root.dataset.end || '');
    const updateSalePercent = now => {
      const saleIsActive = Number.isFinite(start) && Number.isFinite(end) && start < end && now >= start && now < end;
      const beforeSale = Number.isFinite(start) && Number.isFinite(end) && start < end && now < start;
      root.querySelectorAll('[data-wkbf-sale-percent]').forEach(badge => {
        const reference = Number(badge.dataset.referencePrice);
        const salePrice = Number(badge.dataset.salePrice);
        const percent = Math.round((reference - salePrice) / reference * 100);
        const show = (saleIsActive || beforeSale) && reference > 0 && Number.isFinite(salePrice) && salePrice > 0 && salePrice < reference && percent > 0;
        badge.hidden = !show;
        if (show) badge.querySelector('[data-wkbf-off-value]').textContent = `${percent}%`;
      });
    };
    const updateTimer = () => {
      if (!root.isConnected) { clearInterval(interval); return; }
      const now = Date.now();
      updateSalePercent(now);
      const validCampaign = Number.isFinite(start) && Number.isFinite(end) && end > start;
      promo.hidden = !showCountdown || !validCampaign || now >= end;
      if (promo.hidden) {
        if (!validCampaign || now >= end) clearInterval(interval);
        return;
      }
      const beforeSale = now < start;
      timerLabel.textContent = beforeSale ? root.dataset.startLabel : root.dataset.endLabel;
      const target = beforeSale ? start : end;
      let seconds = Math.max(0, Math.floor((target - now) / 1000));
      const days = Math.floor(seconds / 86400); seconds %= 86400;
      const hours = Math.floor(seconds / 3600); seconds %= 3600;
      const minutes = Math.floor(seconds / 60); seconds %= 60;
      timer.textContent = `${String(days).padStart(2,'0')}d : ${String(hours).padStart(2,'0')}h : ${String(minutes).padStart(2,'0')}m : ${String(seconds).padStart(2,'0')}s`;
    };
    const interval = setInterval(updateTimer, 1000);
    updateTimer();
  }
  function initAllWkBlackFriday(container = document) { container.querySelectorAll('[data-wkbf]').forEach(initWkBlackFriday); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAllWkBlackFriday()); else initAllWkBlackFriday();
  document.addEventListener('shopify:section:load', event => initAllWkBlackFriday(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wk-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wk-home-slideshow')) {
    customElements.define('wk-home-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-wk-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-wk-dot]'));
        this.index = 0;
        this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.autoplay = this.dataset.autoplay === 'true';
        this.paused = false;
        this.timer = null;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.prev = () => this.show(this.index - 1);
        this.next = () => this.show(this.index + 1);
        this.toggle = () => {
          this.paused = !this.paused;
          const button = this.querySelector('[data-wk-toggle]');
          button.setAttribute('aria-pressed', String(this.paused));
          button.setAttribute('aria-label', this.paused ? 'Resume banner autoplay' : 'Pause banner autoplay');
          button.textContent = this.paused ? '▶' : 'Ⅱ';
          this.schedule();
        };
        this.stop = () => this.clear();
        this.resume = (event) => {
          if (event.type === 'focusout' && this.contains(event.relatedTarget)) return;
          if (event.type === 'pointerleave' && this.contains(document.activeElement)) return;
          this.schedule();
        };
        this.visibility = () => this.schedule();
        this.querySelector('[data-wk-prev]')?.addEventListener('click', this.prev);
        this.querySelector('[data-wk-next]')?.addEventListener('click', this.next);
        this.querySelector('[data-wk-toggle]')?.addEventListener('click', this.toggle);
        this.dotHandlers = this.dots.map((dot, index) => {
          const handler = () => this.show(index);
          dot.addEventListener('click', handler);
          return handler;
        });
        this.addEventListener('pointerenter', this.stop);
        this.addEventListener('pointerleave', this.resume);
        this.addEventListener('focusin', this.stop);
        this.addEventListener('focusout', this.resume);
        document.addEventListener('visibilitychange', this.visibility);
        this.motion.addEventListener('change', this.visibility);
        this.schedule();
      }
      disconnectedCallback() {
        this.clear();
        this.querySelector('[data-wk-prev]')?.removeEventListener('click', this.prev);
        this.querySelector('[data-wk-next]')?.removeEventListener('click', this.next);
        this.querySelector('[data-wk-toggle]')?.removeEventListener('click', this.toggle);
        this.dots.forEach((dot, index) => dot.removeEventListener('click', this.dotHandlers[index]));
        this.removeEventListener('pointerenter', this.stop);
        this.removeEventListener('pointerleave', this.resume);
        this.removeEventListener('focusin', this.stop);
        this.removeEventListener('focusout', this.resume);
        document.removeEventListener('visibilitychange', this.visibility);
        this.motion.removeEventListener('change', this.visibility);
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        this.schedule();
      }
      clear() {
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = null;
      }
      schedule() {
        this.clear();
        if (!this.autoplay || this.paused || this.slides.length < 2 || this.motion.matches || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
        this.timer = window.setTimeout(() => this.show(this.index + 1), this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
